import { render, staticRenderFns } from "./AddModifier.vue?vue&type=template&id=1eaf8842"
import script from "./AddModifier.vue?vue&type=script&lang=js"
export * from "./AddModifier.vue?vue&type=script&lang=js"
import style0 from "./AddModifier.vue?vue&type=style&index=0&id=1eaf8842&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/share/nginx/html/staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1eaf8842')) {
      api.createRecord('1eaf8842', component.options)
    } else {
      api.reload('1eaf8842', component.options)
    }
    module.hot.accept("./AddModifier.vue?vue&type=template&id=1eaf8842", function () {
      api.rerender('1eaf8842', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/AddModifier.vue"
export default component.exports